import { useEffect, useState } from "react";
import { LuEye, LuEyeClosed } from "react-icons/lu";
import { Link, useNavigate } from "react-router-dom";
import methodModel from "../methods";
import ApiClient from "../api/apiClient";
import { toast } from "react-toastify";
import loader from "../loader";

export default function Reset() {
  const token =localStorage.getItem("token");
  const navigate = useNavigate();
  const [form, setForm] = useState({
    confirmPassword: "",
    newPassword: "",
    verificationCode: "",
    id: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [eyes, setEyes] = useState({
    newPassword: false,
    confirmPassword: false,
  });
  const formValidation = [
    { key: "newPassword", minLength: 8 },
    {
      key: "confirmPassword",
      minLength: 8,
      confirmMatch: ["confirmPassword", "newPassword"],
    },
  ];
  const inValidNewPassword = methodModel.passwordValidation(form?.newPassword);

  useEffect(() => {
    if (token) {
      navigate("/dashboard");
    }
    const userId = methodModel.getPrams("userId") || "";
    const code = methodModel.getPrams("code") || "";
    let params = {
      id: userId || "",
      verificationCode: code || "",
    };
    setForm({ ...form, ...params });
  }, []);

  const getError = (key) => {
    return methodModel.getError(key, form, formValidation);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    let invalid = methodModel.getFormError(formValidation, form);
    if (invalid || !inValidNewPassword) return;
    let payload = {
      id: form?.id,
      password: form?.newPassword,
      verificationCode: form?.verificationCode,
    };
    loader(true);
    const res = await ApiClient.put("user/reset/password", payload);
    if (res.success) {
      toast.success(res.message);
      navigate("/login");
    }
    loader(false);
  };

  return (
    <>
      <div
        className="h-screen overflow-auto flex !bg-bottom !bg-cover !bg-no-repeat p-5"
        style={{ background: "url('assets/img/auth-bg.webp')" }}
      >
        <div className="w-full m-auto">
          <div className="auth-page grid grid-cols-12 gap-3 max-w-[500px] md:max-w-[900px] w-full rounded-[20px] bg-white sm:px-10 p-5 py-10 mx-auto relative">
            <div className="col-span-5 max-md:hidden">
              <div className="flex flex-col gap-y-[6rem] justify-between h-full">
                <Link to="/">
                  <img
                    src="/assets/img/logo.png"
                    class="w-[120px] md:w-[120px] object-contain cursor-pointer mx-auto"
                  />
                </Link>
                <div className="relative top-[10px]">
                  <img
                    src="/assets/img/auth-left-img.png"
                    className="w-full h-full object-contain scale-[1.6]"
                  />
                </div>
              </div>
            </div>
            <div className="col-span-12 md:col-span-7 flex h-full items-center md:ml-[4rem] z-10">
              <form onSubmit={(e) => handleSubmit(e)} className="w-full">
                <div className="space-y-3">
                  <img
                    src="/assets/img/circle-2.png"
                    className="w-125px h-[125px] object-contain absolute right-5 top-0"
                  />
                  <img
                    src="/assets/img/logo.png"
                    class="w-[120px] md:w-[120px] object-contain cursor-pointer mx-auto md:hidden"
                  />
                  <div className="space-y-1">
                    <h3 className="text-2xl text-[#414141] text-center font-semibold">
                      Reset Password
                    </h3>
                    <p className="text-sm text-center text-[#737373]">
                      Please enter a new password for your account
                    </p>
                  </div>
                </div>
                <div className="space-y-4 mt-7">
                  <div className="w-full space-y-1">
                    <label className="text-sm font-[400] text-[#737373]">
                      New Password
                    </label>
                    <div className="relative">
                      <input
                        type={eyes.newPassword ? "text" : "password"}
                        value={form.newPassword}
                        minLength={8}
                        placeholder="New Password"
                        maxLength={16}
                        onChange={(e) =>
                          setForm({ ...form, newPassword: e.target.value })
                        }
                        required
                        className="border !outline-none h-11 rounded-[12px] w-full text-[12px] pl-4 pr-[44px]"
                      />
                      {!eyes.newPassword ? (
                        <LuEyeClosed
                          onClick={() =>
                            setEyes({ ...eyes, newPassword: !eyes.newPassword })
                          }
                          className="text-[#737373] absolute top-[0px] right-[0px] w-[44px] h-[44px] p-[12px] cursor-pointer hover:opacity-70"
                        />
                      ) : (
                        <LuEye
                          onClick={() =>
                            setEyes({ ...eyes, newPassword: !eyes.newPassword })
                          }
                          className="text-[#737373] absolute top-[0px] right-[0px] w-[44px] h-[44px] p-[12px] cursor-pointer hover:opacity-70"
                        />
                      )}
                      {form?.newPassword &&
                        !inValidNewPassword &&
                        submitted && (
                          <span role="alert" className="text-[#c53030] text-xs mt-1 mb-4 block">
                            {methodModel.passwordValidationMessages(
                              form?.newPassword,
                            )}
                          </span>
                        )}
                    </div>
                  </div>
                  <div className="w-full space-y-1">
                    <label className="text-sm font-[400] text-[#737373]">
                      Confirm Password
                    </label>
                    <div className="relative">
                      <input
                        type={eyes.confirmPassword ? "text" : "password"}
                        value={form.confirmPassword}
                        minLength={8}
                        placeholder="Confirm Password"
                        maxLength={16}
                        onChange={(e) =>
                          setForm({ ...form, confirmPassword: e.target.value })
                        }
                        required
                        className="border !outline-none h-11 rounded-[12px] w-full text-[12px] pl-4 pr-[44px]"
                      />
                      {!eyes.confirmPassword ? (
                        <LuEyeClosed
                          onClick={() =>
                            setEyes({
                              ...eyes,
                              confirmPassword: !eyes.confirmPassword,
                            })
                          }
                          className="text-[#737373] absolute top-[0px] right-[0px] w-[44px] h-[44px] p-[12px] cursor-pointer hover:opacity-70"
                        />
                      ) : (
                        <LuEye
                          onClick={() =>
                            setEyes({
                              ...eyes,
                              confirmPassword: !eyes.confirmPassword,
                            })
                          }
                          className="text-[#737373] absolute top-[0px] right-[0px] w-[44px] h-[44px] p-[12px] cursor-pointer hover:opacity-70"
                        />
                      )}
                      {submitted &&
                        getError("confirmPassword").err.confirmMatch && (
                          <span role="alert" className="text-[#c53030] text-xs mt-1 mt-[4px] block">
                            Confirm Password is not matched with New Password
                          </span>
                        )}
                    </div>
                  </div>
                </div>

                <div className="flex gap-5 justify-between mt-8">
                  {/* <Link
                    to="/login"
                    className="bg-white w-full text-sm font-[600] text-gray-600 border h-11 flex items-center justify-center gap-2 rounded-[12px] shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed !px-4"
                  >
                    Cancel
                  </Link> */}
                  <button
                    type="submit"
                    className="bg-[linear-gradient(45deg,#115B9D,#062037)] w-full text-sm font-[600] text-white h-11 flex items-center justify-center gap-2 rounded-[12px] shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed !px-4"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
